/**
 * api接口统一管理
 */
import { get, post } from '@/utils/http'

export const i18n = p => get('/i18n', p)

/**
 * 网站配置
 * @param p
 * @returns {Promise<unknown>}
 */
export const webSiteConfig = p => get('/website-api/v1/index/webSiteConfig', p);

/**
 * 导航
 * @param p "{parentId:'0'}"
 * @returns {Promise<unknown>}
 */
export const navigation = p => post('/website-api/v1/index/navigation', p);
/**
 * 文章列表
 * @param p "{cateId:''}"
 * @returns {Promise<unknown>}
 */
export const articleList = p => post('/website-api/v1/index/articleList', p);
/**
 * 文章详情
 * @param p 文章id
 * @returns {Promise<unknown>}
 */
export const article = p => get('/website-api/v1/index/article/'+p);
/**
 * 广告
 * @param p "{code:'',num:1}"
 * @returns {Promise<unknown>}
 */
export const advertising = p => post('/website-api/v1/index/advertising', p);
/**
 * 变量
 * @param p 变量code
 * @returns {Promise<unknown>}
 */
export const variable = p => get('/website-api/v1/index/variable/'+ p);

/**
 * 分类信息
 * @param p 分类id
 * @returns {Promise<unknown>}
 */
export const cateInfo = p => get('/website-api/v1/index/cateInfo/'+p);
